import styled from 'styled-components';

export const ViewerContainer = styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
  background: rgba(0, 0, 0, 0.9);
  border: 2px solid white;
  border-radius: 12px;
  z-index: 20;
  overflow: hidden;
  box-shadow: 0 0 12px rgba(255, 255, 255, 0.3);
`;

/* Row container for the mode buttons + close button */
export const Toolbar = styled.div`
  position: absolute;
  top: 4px;
  right: 6px;
  display: flex;
  flex-direction: row;
  gap: 6px;
  z-index: 30;
`;

/* Small mode buttons */
export const ModeButton = styled.button<{ active?: boolean }>`
  background: ${({ active }) => (active ? 'rgba(215, 215, 215, 0.75)' : 'black')};
  border: 1px solid white;
  border-radius: 6px;
  padding: 2px 6px;
  color: ${({ active }) => (active ? 'black' : 'white')};
  font-size: 0.8rem;
  cursor: pointer;

  &:hover {
    background: ${({ active }) =>
      active ? 'rgba(255, 255, 255, 0.3)' : 'rgba(255, 255, 255, 0.3)'};
    color: ${({ active }) => (active ? 'white' : 'black')};
  }
`;

/* Close button stays on the far right */
export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  font-size: 1.3rem;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.1s ease;

  &:hover {
    transform: scale(1.2);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const BottomBar = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 10px 12px;
  // background: rgba(0, 0, 0, 0);
  z-index: 20;
`;

export const SegChipButton = styled.button<{
  $bg: string;
  $active?: boolean;
}>`
  border-radius: 99px;
  padding: 6px 10px;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  user-select: none;
  background: ${({ $active, $bg }) => ($active ? $bg : 'transparent')};
  color: ${({ $active }) => ($active ? '#111' : '#fff')};
  border: 2px solid ${({ $bg }) => $bg};
  opacity: ${({ $active }) => ($active ? 1 : 0.85)};
  transition:
    background 0.15s ease,
    color 0.15s ease,
    opacity 0.15s ease,
    transform 0.1s ease;
  &:hover {
    opacity: 1;
  }
  &:active {
    transform: scale(0.97);
  }
`;
